export default __webpack_public_path__ + "static/media/comfortaa-bold-webfont.606fff20.woff";